// extracted by mini-css-extract-plugin
module.exports = {"assignmentinfo":"styles_assignmentinfo__1UY4E","assignment":"styles_assignment__2heRm","assignmentIcon":"styles_assignmentIcon__1k_RO"};